export const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const communityMediaUrl = (id) => `${BACKEND}/api/community/media/${id}/file`;

// Owned generated hero (kept as-is per brief)
export const HERO =
  "https://static.prod-images.emergentagent.com/jobs/60e23e87-a848-4e93-8891-7ae69bc71808/images/e643d7db53af76ae98eb6d33cdedf98948322cd88a78d68cef06771faddb19ec.jpeg";

const px = (id, w) => `https://images.pexels.com/photos/${id}/pexels-photo-${id}.jpeg?auto=compress&cs=tinysrgb&w=${w}`;

// Cinematic media strip — authentic licensed photography (labels come from i18n).
export const MEDIA_IMGS = [px(8624555, 1100), px(10958605, 1100), px(3951292, 1100), px(4894944, 1100), px(3149048, 1100)];

// Profession display order + imagery (text/labels/skills come from i18n by id).
export const PROF_ORDER = ["groomer", "rider", "jockey", "farrier", "trainer", "more"];
export const PROF_IMG = {
  groomer: px(7882885, 900),
  rider: "https://images.unsplash.com/photo-1594768816441-1dd241ffaa67?crop=entropy&cs=srgb&fm=jpg&q=80&w=900&fit=crop&auto=format",
  jockey: px(27981630, 900),
  farrier: px(16273143, 900),
  trainer: px(4894939, 900),
  more: px(15658039, 900),
};

export const HOWITWORKS_IMG = "https://images.unsplash.com/photo-1766858034732-63cffc24120b?crop=entropy&cs=srgb&fm=jpg&q=80&w=900&fit=crop&auto=format";
export const CTA_IMG = "https://images.unsplash.com/photo-1758184487620-430e4f11470d?crop=entropy&cs=srgb&fm=jpg&q=80&w=1600&fit=crop&auto=format";

// Community masonry: key matches backend category (for post matching); label from i18n.
export const COMMUNITY_TILE_META = [
  { key: "Horse Life", img: px(1247000, 800), accent: "#C4A46B" },
  { key: "Fairs & Events", img: px(10958605, 800), accent: "#C4A46B" },
  { key: "Horse News", img: px(3149048, 800), accent: "#3E6B8B" },
  { key: "Incidents & Safety", img: px(15658039, 800), accent: "#B5623C" },
  { key: "Best Practices", img: px(16273143, 800), accent: "#C4A46B" },
  { key: "Learning", img: px(4894939, 800), accent: "#3E6B8B" },
];
